export const UMB_CONTENT_WORKSPACE_IS_LOADED_CONDITION_ALIAS = 'Umb.Condition.Workspace.ContentIsLoaded';
